import React, { useMemo, useState, useCallback } from 'react';
import FluentUiIcon from '../../../../assets/fluent-ui-icon.jsx';
import Lineimg from '../../../../assets/icons/Icon - Line 238.svg';
import '../configured_dashboard.scss';
import PropTypes from 'prop-types';
import TasksModalBase from '../helper/task-modal-base';

const formatCount = (count) => {
  if (!Number.isFinite(count)) return 0;
  if (count >= 1000) {
    const truncatedCount = count / 1000;
    return `${truncatedCount.toFixed(truncatedCount >= 10 ? 0 : 1)}k`;
  }
  return count;
};

const MetricCounter = ({ bigNumbersWidgetData }) => {
  const [showModal, setShowModal] = useState(false);
  const [activeLabel, setActiveLabel] = useState(null);
  const [activeTasks, setActiveTasks] = useState([]);

  const metrics = useMemo(() => ([
    {
      key: 'Backlog',
      count: bigNumbersWidgetData?.BacklogCount ?? 0,
      label: 'In Backlog',
      icon: 'ClipboardTextLtrRegular',
      iconColor: '#707070',
      backgroundColor: '#F0F0F0',
      tasksKey: 'BackLogTasks',
    },
    {
      key: 'Investigation',
      count: bigNumbersWidgetData?.InvestigationCount ?? 0,
      label: 'Under Investigation',
      icon: 'SlideSearchRegular',
      iconColor: '#0F6CBD',
      backgroundColor: '#EBF3FC',
      tasksKey: 'InvestigationTasks',
    },
    {
      key: 'FinalDecision',
      count: bigNumbersWidgetData?.FinalDecisionCount ?? 0,
      label: 'Awaiting Final Decision',
      icon: 'ApprovalsAppRegular',
      iconColor: '#E55010',
      backgroundColor: '#FFEED6',
      tasksKey: 'FinalDecisionTasks',
    },
    {
      key: 'Approved',
      count: bigNumbersWidgetData?.ApprovedCount ?? 0,
      label: 'Approved for Filing',
      icon: 'CalendarCheckmarkRegular',
      iconColor: '#0E700E',
      backgroundColor: '#F1FAF1',
      tasksKey: 'ApprovedTasks',
    },
  ]), [bigNumbersWidgetData]);

  const handleOpen = useCallback((metric) => {
    const list = bigNumbersWidgetData?.[metric.tasksKey] ?? [];
    setActiveTasks(Array.isArray(list) ? list : []);
    setActiveLabel(metric.label);
    setShowModal(true);
  }, [bigNumbersWidgetData]);

  const handleClose = useCallback(() => {
    setShowModal(false);
    setActiveLabel(null);
    setActiveTasks([]);
  }, []);

  return (
    <div className="MetricWrapperConfigurable">
      <div className="row metrics-container">
        {metrics.map((metric, index) => (
          <React.Fragment key={metric.key}>
            <div
              className="col metric-item"
              role="button"
              tabIndex={0}
              onClick={() => handleOpen(metric)}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleOpen(metric)}
            >
              <div className="metrics-icon-container" style={{ backgroundColor: metric.backgroundColor }}>
                <FluentUiIcon name={metric.icon} size={28} color={metric.iconColor} />
              </div>
              <div className="metric-text">
                <span className="metric-number">{formatCount(metric.count)}</span>
                <p className="metric-label">{metric.label}</p>
              </div>
            </div>
            {index < metrics.length - 1 && (
              <div className="col-auto">
                <img src={Lineimg} className="metric-line" alt="Line Divider" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      <TasksModalBase
        show={showModal}
        onHide={handleClose}
        title={activeLabel || "Tasks"}
        subtitle="Actionable STRs"
        tasks={activeTasks}
      />
    </div>
  );
};

MetricCounter.propTypes = {
  bigNumbersWidgetData: PropTypes.shape({
    BacklogCount: PropTypes.number,
    InvestigationCount: PropTypes.number,
    FinalDecisionCount: PropTypes.number,
    ApprovedCount: PropTypes.number,
    BackLogTasks: PropTypes.arrayOf(PropTypes.object),
    InvestigationTasks: PropTypes.arrayOf(PropTypes.object),
    FinalDecisionTasks: PropTypes.arrayOf(PropTypes.object),
    ApprovedTasks: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default MetricCounter;